/* eslint-env jest */
import buyAllCardModel, { FREE_MAGNETS_RIBBON } from './buyAllCardModel';

// The Buy All Digital card per offer type (issue #5218 item 6). Prices are the
// real EL Fall 2027 All Digital figure so the strike-through reads as the
// storefront will show it: $49.94 -> $39.95 under ELEM20.
const option = { id: 2861, name: 'All Digital Package', price: 49.94 };
const pct = { couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20, code: 'ELEM20' };
const magnets = { couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0, code: 'ELEMMAGNETS' };

describe('buyAllCardModel', () => {
  it('with a % offer live: the 20% ribbon and the discountedPrice() strike-through', () => {
    const m = buyAllCardModel({ option, offer: pct });
    expect(m.ribbon).toBe('20% OFF');
    expect(m.wasPrice).toBe(49.94);
    expect(m.nowPrice).toBeCloseTo(39.95, 2);
    expect(m.freeMagnets).toBe(false);
  });

  it('with the magnet tier live: "+2 FREE MAGNETS" and the real price, no strike-through', () => {
    const m = buyAllCardModel({ option, offer: magnets });
    expect(m.ribbon).toBe(FREE_MAGNETS_RIBBON);
    expect(m.wasPrice).toBeNull();
    expect(m.nowPrice).toBe(49.94);
    expect(m.freeMagnets).toBe(true);
  });

  it('with no offer: the real price only', () => {
    const m = buyAllCardModel({ option, offer: null });
    expect(m).toEqual({
      price: 49.94, wasPrice: null, nowPrice: 49.94, ribbon: null, freeMagnets: false,
    });
  });

  it('a flat-rate offer has no honest per-card price, so no ribbon and no strike-through', () => {
    const m = buyAllCardModel({ option, offer: { couponType: 'FLAT_RATE_WITH_FREE_SHIPPING', value: 10 } });
    expect(m.ribbon).toBeNull();
    expect(m.wasPrice).toBeNull();
    expect(m.nowPrice).toBe(49.94);
  });

  it('survives a string price (params arrive as strings) and a missing option', () => {
    expect(buyAllCardModel({ option: { price: '49.94' }, offer: pct }).nowPrice).toBeCloseTo(39.95, 2);
    expect(buyAllCardModel({ option: null, offer: pct })).toMatchObject({ price: null, nowPrice: null, ribbon: null });
  });
});

describe('buyAllCardModel — free item of your choice (#5747)', () => {
  it('with the free-item offer live: a "+ FREE MAGNET" ribbon and the real price', () => {
    const freeItem = {
      couponType: 'FREE_ADDON_CHOICE', value: 0, code: 'FREEMAGNET',
      freeAddons: [{ name: 'Weekly Dry Erase Magnet - School', giftCategory: 'magnets' }],
    };
    const m = buyAllCardModel({ option, offer: freeItem });
    expect(m.ribbon).toBe('+ FREE MAGNET');
    expect(m.wasPrice).toBeNull();
    expect(m.nowPrice).toBe(49.94);
    expect(m.freeMagnets).toBe(false);
  });
});
